// Modules
import React from 'react';
import PropTypes from 'prop-types';

// Styles
import * as S from './styles';

const Radio = (props) => (
  <S.LabelRadio htmlFor={props.id}>
      <S.InputRadio id={props.id} type="radio" value={props.value} name={props.name} ref={props.innerRef} {...props} />
      {props.text}
  </S.LabelRadio>
)

Radio.propTypes = {
    id: PropTypes.node,
    value: PropTypes.node,
    name: PropTypes.string,
    text: PropTypes.string
}

Radio.defaultProps = {
    text: "Text"
}

export default Radio;